import React, { useContext } from "react";

import constant from "lib/constant/constant";

import { PrivateContext } from "lib/context";
import { Spinner } from "lib/components";
import { storageHelper } from "lib/helpers";
import { AdminOrderSlip } from "./admin/features";
import { OperatorOrderSlip } from "./operator/features";
import { ProviderOrderSlip } from "./provider/features";

const { userKey } = constant;
const { admin, operator, provider } = userKey;

const OrderSlip = () => {
  const { isLoading } = useContext(PrivateContext);
  const getComponent = (role) => {
    if (isLoading) {
      return <Spinner isFullPage />;
    }

    if (role === admin) {
      return <AdminOrderSlip />;
    }
    if (role === operator) {
      return <OperatorOrderSlip />;
    }
    if (role === provider) {
      return <ProviderOrderSlip />;
    }
    return null;
  };

  const currentUserRole = storageHelper.get("userRole");
  const OrderSlipComponent = getComponent(currentUserRole);
  return OrderSlipComponent;
};

export default OrderSlip;
